"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = notifications;

var _simpleUpdateIn = _interopRequireDefault(require("simple-update-in"));

var _dismissNotification = require("../actions/dismissNotification");

var _sagaError = require("../actions/sagaError");

var _setNotification = require("../actions/setNotification");

var DEFAULT_STATE = {};

function notifications() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  var now = Date.now();

  if (type === _dismissNotification.DISMISS_NOTIFICATION) {
    state = (0, _simpleUpdateIn["default"])(state, [payload.id]);
  } else if (type === _sagaError.SAGA_ERROR) {
    state = (0, _simpleUpdateIn["default"])(state, ['connectivitystatus', 'message'], function () {
      return 'javascripterror';
    });
  } else if (type === _setNotification.SET_NOTIFICATION) {
    var alt = payload.alt,
        data = payload.data,
        id = payload.id,
        level = payload.level,
        message = payload.message;
    var notification = state[id];

    if (!notification || alt !== notification.alt || !Object.is(data, notification.data) || level !== notification.level || message !== notification.message) {
      state = (0, _simpleUpdateIn["default"])(state, [id], function () {
        return {
          alt: alt,
          data: data,
          id: id,
          level: level,
          message: message,
          timestamp: now
        };
      });
    }
  }

  return state;
}